const str = `{HEADER}プライバシーポリシー
{HEADER_SUB}（株）ビデオモンスター（以下　‘当社’といいます）は、‘個人情報保護法’、‘情報通信網の利用促進及び情報保護についての法令’をはじめ、全ての個人情報保護に関する法令規定を遵守し、個人情報の保護を推進してまいります。当社の個人情報取り扱い方針を別枠で制定し遵守する事により、利用者の個人情報保護の為最善の努力をいたしております。


{BODY_TITLE}第一章　総則　
１）‘個人情報’とは、生存する個人に対する情報として本サービス情報に含まれている氏名（ニックネーム）、eメールなどの事項により個人を識別できる情報（本情報のみでは特定個人の識別が難易であっても他の情報と適切に結合し識別が可能な事を含みます）をいいます。
２）当社は、プライバシーポリシーをホームページ、又はアプリケーションに提供することにより、お客様にはいつでも容易に閲覧できるように努めます。
３）当社は、プライバシーポリシーにおいて持続的に改善できるよう、プライバシーポリシーの改正に必要な手続きを定めており、プライバシーポリシーを改正する場合には識別番号を付与し、改正された項目をお客様にも速やかに区別できるよう対応いたします。


{BODY_TITLE}第二章　個人情報の項目及び収集方法
１）当社は、会員登録や速やかな相談窓口、有料サービス提供の為下記のような個人情報を収集しております。満１４歳未満の場合には、会員登録又は本サービスの利用を制限させていただきます。
２）NAVER，Google，Facebookなどの簡便会員登録やログインの際には、当メディアに提供する情報（公開プロフィール，eメール，生年月日，写真や動画など）が収集されます。
３）収集する個人情報の項目
①必須入力項目
−　氏名（ニックネーム），会員ID（eメール住所と同様），パスワード，満１４歳以上かの確認可否
②選択入力項目
− 性別，年代，住所，職種，使用用途，連絡先，電話番号，推薦人
③有料サービス利用過程での収集される情報として、決済過程でのみの利用とし当社には一切記録されません。
− 共通：氏名（本名），電話番号
− クレジットカード決済の場合：カード名，カード番号，有効期間
− モバイルペイ決済の場合：電話番号，通信会社，生年月日，決済承認番号など
− 口座振り込み決済の場合：銀行名，口座番号
− 商品券決済の場合：商品券番号
④サービス利用過程や事業処理過程に伴い下記の情報などが自動的に生産され収集される場合があります。
− サービス利用記録，接続ログ，クッキー（cookie），接続IP情報，決済記録，利用停止記録など
４）収集方法
①ホームページ，書面様式，ファックス，eメールを通した会員登録
②電話，相談掲示板，イベント応募，配送要請


{BODY_TITLE}第三章　個人情報収集に対する同意
１）当社は、お客様が当社のプライバシーポリシーをご確認できるよう表記し、同意された後に会員登録ができる環境を整えます。
２）当社は、会員登録時に収集する会員の個人情報に関連して個人情報保護法による収集項目，利用目的などを告知し同意を得させて頂きます。


{BODY_TITLE}第四章　個人情報の収集及び利用目的
当社は以下のような目的の為に個人情報を収集し、収集する個人情報項目による具体的な収集目的及び利用目的は以下同様とします。
①須入力項目
− 氏名（ニックネーム），会員ID（ eメール住所と同様），パスワード：サービス利用時本人識別過程に使用
− 満１４歳未満可否：満１４歳未満のお子様である場合、会員登録又はサービス利用の制限の為に必要
− 会員ID（eメール住所と同様）：告知事項伝達，本人の意思確認，苦情処理などの円滑なコミュニケーション経路の確保，新たなサービス，イベント情報の案内
− メール受信可否（ニュースレター，決済内訳）：アップデート情報，イベント案内，決済内容などのeメール受信可否確認
②選択入力項目
− 性別，職種，使用用途，連絡先，電話番号，推薦人：当社の発展方向のための参考用情報確保
− 連絡先，住所：イベント，景品提供時参加者の適合性確認及び配送についての正確な配送先の確保
２）当社は利用者の基本的な人権侵害に恐れのある、敏感な個人情報（人種や民族、思想及び信条，出身地，本籍地，政治的性向や犯罪記録，健康状態，性生活など）は収集いたしません。


{BODY_TITLE}第五章　個人情報自動収集装置の設置/運営及び拒否に関する事項
当社はお客様の情報を随時保存し探し出すクッキー（cookie）を使用します。クッキーとは、ビデオモンスター接続時自動的にお客様のコンピューターに転送される４KB未満のテキストファイルとして、お客様のハードディスクに保存されます。
１）クッキーの使用目的
お客様の訪問又は利用形態，セキュリティ接続可否，広告を含む最適化されたオーダーメイド情報を提供するために使用されます。
２）クッキーの設置/運営及び拒否
①お客様はクッキーに関する選択権を持っています。したがってお客様が使用されるwebブラウザのオプションを設定する事により、全てのクッキーを許容する事や、クッキーが保存される度に確認を経たりする事又は全てのクッキーの保存を拒否する事もできます。
②設定方法　例（google chrome）
右上の‘もっと見る’＞　設定　＞　個人情報及びセキュリティ　＞　クッキー又はその他利用データ
クッキーの保存を拒否する場合、サービス利用に支障が生じる可能性があります。


{BODY_TITLE}第六章　目的外の使用及び第三者に対する提供，共有
１）当社はお客様の個人情報を「個人情報の収集及び利用目的」から告知した範囲内で使用し、範囲を超えての利用や他人又は他企業，機関など、外部には公開いたしません。
２）以下の場合には例外とさせていただきます。
①関係法令により捜査上の目的で関係機関からの要求がある場合
②統計作成，学術研究や市場調査の為の特定個人の識別が不可能な形態で、広告主，協力会社や研究団体などに提供する場合
③その他の関係法令が定めた手続きによる要求がある場合
④例外事項の内、関係法令による捜査機関の要求により情報を提供する場合でも、当事者に告知する事を原則として運営しております。法律上の根拠について、やむを得ず告知が出来ない場合もあります。
３）本来の収集目的及び利用目的に反して、無分別な情報提供されないよう最善を尽くし努力いたします。


{BODY_TITLE}第七章　個人情報の委託取扱
１）当社はサービス向上の為、以下同様個人情報の委託をしており、関係法令による委託契約時に個人情報が安全に管理できるよう、必要な事項を既定しています。
２）当社の個人情報委託処理機関及び委託業務内容は以下同様でございます。
− 受託業者：Google
− 委託内容：使用データ分析（Google Analytics）及びデータ保存（Google Cloud Platform）
{ADD_LINE}
- 受託業者：Microsoft Azure
− 委託内容：データ保存（ Microsoft Cloud Services）
{ADD_LINE}
− 受託業者：MailChimp
− 委託内容：eメールコミュニケーション支援
{ADD_LINE}
- 受託業者：Facebook
− 委託内容：個人化したお客様経験サポート
{ADD_LINE}
- 受託業者：Salesforce
− 委託内容：データ保存，お客様相談窓口支援
{ADD_LINE}
- 受託業者：INICIS
− 委託内容：決済代行
{ADD_LINE}
- 受託業者：Zencoder
− 委託内容：利用者がアップロードした動画ファイルの変換


{BODY_TITLE}第八章　利用者及び法定代理人の権利とその行使方法
１）お客様は当社に関していつでも次の項目の個人情報保護関連権利を行使できます。
①個人情報閲覧要求
②エラーなどがある場合訂正要求
③削除要求
④処理中断要求
２）第１項による権利行使はホームページログイン後、右上のマイムービー　＞　アカウント設定から直接閲覧及び訂正、脱退要求をするか、利用者本人の訪問又は個人情報管理責任者及び担当者に連絡、eメールやFaxなどの手段で連絡してくだされば、本人可否確認後速やかに措置させていただきます。
３）お客様の個人情報エラーについての訂正又は削除を要求する場合、当社は訂正及び削除を完了するまで個人情報を使用するなど提供したり
いたしません。


{BODY_TITLE}第九章　個人情報破棄及び分離保管
お客様の個人情報は原則的に個人情報の収集及び使用目的が達成した場合、遅滞なく破棄させていただきます。当社の個人情報破棄手続きや方法は以下同様でございます。
１）破棄手続き
①利用者が会員登録などの為に入力した情報は、目的が達成された後別のDB（用紙の場合他の書類）に移され内部方針及びその他関連法令による情報保護事由より（保有又は利用期間参照）一定期間保存された後破棄されます。
②別のDBに移された個人情報は、法律による場合では無い限り保有される以外の目的では使用されません。
２）破棄方法
①電子ファイルに保存された個人情報は記録を再生させる事の出来ない技術を作用し削除いたします。
②用紙に出力された個人情報は粉砕機で粉砕するか、焼却を通して破棄させていただきます。
３）分離保管
①連続して１年の間ビデオモンスターサービスを利用しなかった会員（長期未使用者）の個人情報を別で分離保管させていただきます。
②分離保管された会員の情報は休眠アカウントに転換され、休眠アカウント転換後にログインされる場合には休眠解除されます。
③分離保管された会員の情報は関連法令による一定期間保有後、一定期間が過ぎた場合に破棄されます。


{BODY_TITLE}第十章　個人情報の保有及び使用期間
お客様の個人情報は原則的に、個人情報の収集目的又は提供される目的が達成した後破棄されます。ただし、次の情報については以下の理由から表記されている期間の間保存いたします。
１）当社内部方針による情報保有理由
①不正使用者記録
− 保存理由：不正利用者の再加入防止，名誉毀損など、権利侵害紛争及び捜査協調
− 保存期間：１年
{ADD_LINE}
２）関連法令による情報保有理由
①契約又は契約の申し込みの撤回などに関する記録
− 保存理由：電子商取引などの消費者保護に関する法律
− 保存期間：５年
{ADD_LINE}
②代金決済及び財貨などの供給に関する記録
− 保存理由：電子商取引などの消費者保護に関する法律
− 保存期間：５年
{ADD_LINE}
③消費者の不満及び紛争処理に関する記録
− 保存理由：電子商取引などの消費者保護に関する法
− 保存期間：３年
{ADD_LINE}
④訪問記録
− 保存理由：通信パスワード法
− 保存期間：３ヶ月


{BODY_TITLE}第十一章　個人情報の為の技術及び管理的対策
当社はお客様の個人情報保護を管理する事にあり、個人情報が紛失，盗難，漏出，変調又は棄損されないよう安全性確保の為、以下のような技術的対策を講じています。
１）個人情報保護の為の技術的対策
①お客様の個人情報はパスワードにより保護され、利用者IDのパスワードは本人のみ知る事が出来ます。個人情報確認及び変更もパスワードを知っている本人のみ可能でございます。
②当社はハッキングなど外部侵略に備えて、お客様の個人情報が流出される事を防ぐため現在外部からの侵略を遮断する装置を使用し、外部からの攻撃，ハッキングを防いでいます。中でも、利用者の個人情報を持っているサーバーについては高水準の保安を維持しております。
③当社はもしもの事態に備えてシステムとデータをバックアップすることの出来る体制をとっています。
２）個人情報の為の管理的対策
①当社はお客様の個人情報に対するアクセス権限を最小限の人員にのみに制限しております。最小限人員に該当する者は以下同様でございます。
− 使用者を直接相手にマーケティング業務を随行する者
−　個人情報管理責任者及び担当者など、個人情報保護管理業務を随行する者
− その他業務上個人情報扱いが不可避な者
②個人情報を扱う職員を対象に新たな保安技術取得及び個人情報保護義務などの長期的な社内教育又は外部委託教育を実施しております。
③入社時、前職員の保安誓約書を通して人による情報流出を事前に防止し、プライバシーポリシーに関する履行事項及び職員の遵守可否を監視する為の内部手続きを用意しております。
④個人情報関連取扱責任者の業務引き継ぎは、保安が維持できている状態で徹底的に行われている為、入社や退社後個人情報事故に対する責任を明確化しております。
⑤当社は利用者個人の手違いや基本的なインターネットの危険性による起こる事の責任は負いません。お客様個人個人が本人の個人情報を保護する為に本人のIDやパスワードを適切に管理し、事に関する責任を負わなければいけません。
⑥その他の内部管理者の手違いや、技術管理上の事故による個人情報の喪失，流出，変調，棄損が誘発する場合、当社は即お客様に事実を告げ適切な対策と補償を講じさせていただきます。


{BODY_TITLE}第十二章　外部サイトからの流入
１）当社はお客様に他社のwebサイト又は資料についてのリンクを提供させていただく事ができます。この場合、当社は外部サイト及び資料についてどのような統制権も無く、そこから提供されるサービスや資料の有用性についての責任を負うことが出来ない為保証できません。
２）当社が含めているリンクをクリック（click）し、違うサイトのページに移る場合本サイトのプライバシーポリシーは当社とは無関係な為、新しく訪問したサイトのポリシーをお確かめください。


{BODY_TITLE}第十三章　広告性情報送信
１）当社はお客様の明示的な受信拒否意思に反した営利目的の広告性情報は送信いたしません。
２）当社はお客様のニュースレターや電子メール送信に関する合意の上で、電子メールの題名及び本文欄に次のようにお客様が容易にお判りになりますよう処置します。
①電子メール題名欄：［広告］という文句を題名に表記しない場合があり、電子メール本文欄に主な内容を表記します。


{BODY_TITLE}第十四章　告知の義務
現　プライバシーポリシーは、政府の政策及び保安技術の変更により内容の追加、削除や修正がある場合には改正前少なくとも7日前からホームページを通し告知させていただきます。


{BODY_TITLE}第十五章　個人情報管理責任者及び担当者
当社はお客様が良い情報を安全に利用できますよう最善を尽くしております。お客様の個人情報を扱う責任者及び担当者は以下の様になっており、個人情報関連お問い合わせに速やかかつ誠実にお答えさせていただきます。
個人情報管理責任者
− 氏名：ジョン・ドンヒョク
− 所属：個人情報管理チーム
− 職位：代表取締役
− 電子メール：support@videomonster.com
− 電話番号：０２−５５４−６８０１
{ADD_LINE}
個人情報管理担当者
− 氏名：イ・ウソプ
− 所属：個人情報保護チーム
− 職位：技術責任者
− 電子メール：support@videomonster.com
− 電話番号：０２−５５４−６８０１
{ADD_LINE}
その他、個人情報に関する申告やお問い合わせが必要な場合以下の機関にお問い合わせください。
個人情報侵害申告センター（privacy.kisa.or.kr/118）
大検察庁サイバー捜査課（www.spo.go.kr/1301）
警察庁サイバー安全局（www.ctrc.go.kr/182）

{FOOTER}<付則>
{FOOTER_SUB}本政策は２０２１年０5月０１日から施行します。
`

export default str